module.exports = __webpack_public_path__ + "media/images/gallery/constellations/rn_layer_on-0fbded2dfa40f04957493de6e1bcbd22.jpg";